import { render, staticRenderFns } from "./Farmaciapendientes.vue?vue&type=template&id=37b963da&"
import script from "./Farmaciapendientes.vue?vue&type=script&lang=js&"
export * from "./Farmaciapendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports